import moment from 'moment';
import { getNextQuarter } from './helpers';

// Anticipación mínima con la que un alumno puede agendar una tutoría.
// Le da al profesor al menos un día para revisar su correo y organizarse.
// Este valor es sólo la validación del formulario: la fuente de verdad es
// Lesson::SCHEDULE_THRESHOLD en yoda-backend.
export const MIN_SCHEDULE_HOURS = 24;

export function getMinScheduleMoment() {
  return getNextQuarter(moment().add(MIN_SCHEDULE_HOURS, 'hour'));
}

// Primer día que tiene al menos un horario agendable.
export function getFirstSchedulableDay() {
  return getMinScheduleMoment().startOf('day');
}

// Un día completo queda fuera de plazo cuando incluso su último minuto
// ocurre antes de la anticipación mínima.
export function isDayBeforeMinSchedule(dayMoment) {
  return dayMoment.clone().endOf('day') < getMinScheduleMoment();
}
